module.exports = __webpack_public_path__ + "static/media/wifi-router.5215dc37.svg";